import React from "react"

const SectionHeader = ({ icon, title, action }) => {
  return (
    <div className="d-flex justify-content-between align-items-center mb-3">
      <h6 className="mb-0 d-flex align-items-center fw-semibold">
        {icon && <i className={`${icon} me-2`}></i>}
        {title}
      </h6>
      {action && <div>{action}</div>}
    </div>
  )
}

export default SectionHeader
